import angular from 'angular';
import {
  difference,
  filter,
  find,
  get,
  groupBy,
  includes,
  isEmpty,
  isNumber,
  map,
  orderBy,
  pick,
  pull,
  set,
  some,
  omit,
} from 'lodash';
import '../../services/category';
import '../../services/line-flow-type-organization';
import '../../services/organization';
import '../../services/organization-messages';
import '../../services/organization-scenario';
import '../../services/plan';
import { localStorage, options, validPhone, unitOfTime } from '../../utils';
import schedule from '../../utils/schedules';

const module = angular.module('whyline.modals.organization', [
  'whyline.services.organization',
  'whyline.services.organization-scenario',
  'whyline.services.organization-messages',
  'whyline.services.line-flow-type-organization',
  'whyline.services.plan',
  'whyline.services.category',
]);

const OrganizationModalController = (
  $scope,
  $uibModalInstance,
  $timeout,
  $translate,
  dialog,
  Slug,
  OrganizationService,
  organizationId,
  TimezoneService,
  NotificationService,
  PlanService,
  CategoryService,
  ErrorService,
  LineFlowTypeOrganizationService,
  OrganizationScenarioService,
  OrganizationMessagesService,
  blockUI,
) => {
  /* @ngInject */

  const namePattern = /^[\u0621-\u064Aa-zA-Zàáâäãåąč&ćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽð:/ ,.'-+\d.*-]+$/;
  $scope.hours = schedule.getHour();
  $scope.minutes = schedule.getMinutes();
  $scope.currentLanguage = $translate.use();
  $scope.languages = {
    list: { en: 'English', es: 'Español', pt: 'Portugués', fr: 'Frances' },
  };
  $scope.urlPattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
  $scope.validEmail = /^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,5})$/;
  $scope.organization = {};
  $scope.organizationGeneral = {};
  $scope.organizationConfiguration = {};
  $scope.organizationAgenda = {};
  $scope.organizationMessages = [];
  $scope.organizationEmails = {};
  $scope.endUserPersonalData = [];
  $scope.hack = { organizationOneLoginEnabled: false };
  $scope.file = [];
  $scope.organizationOneLogin = {
    passportConfig: {
      authorizationURL: '',
      callbackURL: '',
      clientID: '',
      clientSecret: '',
      issuer: '',
      passReqToCallback: true,
      tokenURL: '',
      userInfoURL: '',
    },
    slug: '',
  };
  $scope.plans = [];
  $scope.lineFlowTypeOrganizationList = [];
  $scope.lineFlowTypeOrganizationSelected = {};
  $scope.scenarioSelected = {};
  $scope.timezones = { list: TimezoneService.List };
  $scope.surveyMonkey = {};
  $scope.minPeopleAheadValue = 3;
  $scope.maxPeopleAheadValue = 10;
  $scope.headerBackground = '';
  $scope.idFieldRequired = false;
  $scope.nameAndLastNameFieldsRequired = false;
  $scope.errorPeopleAhead = false;

  const applyToOrganizationOrAllPlaces = {
    options: options.filter((o) => o.onlyOrganizations || o.all),
    selectedOption: options.filter((o) => o.onlyOrganizations || o.all)[0].key,
  };
  $scope.editMessagesScope = { ...applyToOrganizationOrAllPlaces };
  $scope.noAppointmentsAvailableMessageApplyIn = { ...applyToOrganizationOrAllPlaces };
  $scope.selectDataForOverbooking = { ...applyToOrganizationOrAllPlaces };
  $scope.applyUserDataSettings = { ...applyToOrganizationOrAllPlaces };
  $scope.overlapAppointment = { ...applyToOrganizationOrAllPlaces };
  $scope.editCallLogicsScope = {
    options: options.filter((o) => o.onlyOrganizations || o.all || o.orgPlacesLines),
    selectedOption: options.filter((o) => o.onlyOrganizations || o.all || o.orgPlacesLines)[0].key,
  };

  $scope.delayDeliveryUnitOfTime = {
    options: unitOfTime,
  };
  $scope.disableFullNameAlias = false;
  const user = localStorage.get('user');
  $scope.superAdmin = user && user.sudo;

  $scope.orgAdmin =
    user &&
    user.permissions.filter(
      (p) => p.role.name === 'Organization Admin' && p.role.organizationId === organizationId,
    );

  const SUPPORTED_LANGUAGES = ['en', 'es', 'pt', 'fr'];
  const DEFAULT_LANGUAGE = 'en';
  const language = includes(SUPPORTED_LANGUAGES, $translate.use())
    ? $translate.use()
    : DEFAULT_LANGUAGE;

  const field = `name_${language}`;

  const getSlugForEmails = (isAirport) => {
    const subjects = get($scope.organization, 'emails.subjects', []);
    const sortedSubjects = orderBy(subjects, ['slug'], ['asc']);
    $scope.organizationEmails = groupBy(sortedSubjects, (e) => e.slug);
    if (!isAirport) {
      delete $scope.organizationEmails['whyline-aviation-date-changed'];
      delete $scope.organizationEmails['whyline-aviation-vq-changed'];
      delete $scope.organizationEmails['whyline-aviation-flight-cancellation'];
    }
  };

  $scope.changeEnabledEmails = (key, value) => {
    const emails = $scope.organizationEmails[key];
    emails.forEach(email => {
      email.enabled = value;
    });
  };

  const getImagesForEmails = () => {
    const bannerImage = get($scope.organization, 'emails.banner.image', null);
    const footerImage = get($scope.organization, 'emails.footer.image', null);
    const defaultImage = 'img/common/placeholder-place.png';
    $scope.emailsBannerImage = bannerImage || defaultImage;
    $scope.emailsFooterImage = footerImage || defaultImage;
  };

  const getEndUserPersonalData = () => {
    const endUserDataKeys = Object.keys($scope.organizationConfiguration.endUserPersonalData);

    endUserDataKeys.forEach((key) => {
      const value = {
        name: key,
        qmsShow: $scope.organizationConfiguration.endUserPersonalData[key].qms.show,
        qmsRequired: $scope.organizationConfiguration.endUserPersonalData[key].qms.required,
        webAgendaShow: $scope.organizationConfiguration.endUserPersonalData[key].webAgenda.show,
        webAgendaRequired:
          $scope.organizationConfiguration.endUserPersonalData[key].webAgenda.required,
      };
      $scope.endUserPersonalData.push(value);
    });
  };

  $scope.categoriesSettings = {
    template: `<b>{{option.${field}}}</b>`,
    externalIdProp: 'category',
    displayProp: field,
    idProp: '_id',
    searchField: field,
    enableSearch: true,
    keyboardControls: true,
    selectedToTop: true,
    scrollable: true,
  };

  $scope.tooltips = {
    checkInEarly: 'tooltip_check_in_early',
    numberPeopleAhead: 'tooltip_people_ahead',
    youAreNext: 'tooltip_you_are_next',
    checkIn: 'tooltip_check_in',
    itsYourTurn: 'tooltip_its_your_turn',
  };

  $scope.multiselectTranslations = {
    checkAll: $translate.instant('multiselect_todos'),
    uncheckAll: $translate.instant('multiselect_ninguno'),
    dynamicButtonTextSuffix: $translate.instant('multiselect_seleccionados'),
    buttonDefaultText: $translate.instant('multiselect_seleccionar'),
    searchPlaceholder: $translate.instant('multiselect_buscar'),
    selectionCount: $translate.instant('multiselect_seleccionados'),
  };

  $scope.cancel = () => {
    dialog
      .confirm($translate.instant('modal_cancel'))
      .then(() => $uibModalInstance.dismiss('cancel'))
      .catch(() => 'canceled');
  };

  $scope.modifyShowOrRequiredValue = (fieldName, value, action, applyTo) => {
    const personalData = $scope.endUserPersonalData.find((pd) => pd.name === fieldName);

    if (action.includes('required') && value) {
      const completedName = `${applyTo}Show`;
      personalData[completedName] = true;
    }

    if (action.includes('show') && !value) {
      const completedName = `${applyTo}Required`;
      personalData[completedName] = false;
    }
  };

  $scope.checkAliasType = (fieldName) => {
    if (fieldName === 'identification' || fieldName === 'name' || fieldName === 'lastName') {
      if (fieldName === 'identification') {
        const idField = $scope.endUserPersonalData.find((data) => data.name === fieldName);
        $scope.idFieldRequired = idField.qmsRequired && idField.webAgendaRequired;
      }

      if (fieldName === 'name' || fieldName === 'lastName') {
        const lookSettingsFor = fieldName === 'name' ? 'lastName' : 'name';
        const fieldChanged = $scope.endUserPersonalData.find((data) => data.name === fieldName);
        const anotherNameField = $scope.endUserPersonalData.find(
          (data) => data.name === lookSettingsFor,
        );

        $scope.nameAndLastNameFieldsRequired =
          fieldChanged.qmsRequired &&
          fieldChanged.webAgendaRequired &&
          anotherNameField.qmsRequired &&
          anotherNameField.webAgendaRequired;
      }

      const aliasType = get($scope, 'organization.configuration.queuer.aliasType');
      if (
        (aliasType === 'lastIdAlias' || aliasType === 'fullNameAlias') &&
        !$scope.idFieldRequired &&
        !$scope.nameAndLastNameFieldsRequired
      ) {
        $scope.organization.configuration.queuer.aliasType = 'prefixWithIncrementalNumberAlias';
      } else if (
        aliasType === 'lastIdAlias' &&
        !$scope.idFieldRequired &&
        $scope.nameAndLastNameFieldsRequired
      ) {
        $scope.organization.configuration.queuer.aliasType = 'fullNameAlias';
      } else if (
        aliasType === 'fullNameAlias' &&
        !$scope.nameAndLastNameFieldsRequired &&
        $scope.idFieldRequired
      ) {
        $scope.organization.configuration.queuer.aliasType = 'lastIdAlias';
      }

      if (aliasType !== $scope.organization.configuration.queuer.aliasType) {
        NotificationService.Information(
          $translate
            .instant('alias_has_been_changed')
            .replace(
              '{aliasType}',
              $translate.instant($scope.organization.configuration.queuer.aliasType),
            ),
        );
      }
    }
  };

  $scope.setMinorThanZero = (value, property) => {
    if (value < -1 && $scope.organizationConfiguration.plan.hasOwnProperty(property)) {
      $scope.organizationConfiguration.plan[property] = -1;
    } else if (value === '' || value === null) {
      $scope.organizationConfiguration.plan[property] = 0;
    }
  };

  $scope.changeIdToPlanId = (plan) => {
    if (!plan) {
      return;
    }
    $scope.organizationConfiguration.plan = {
      ...plan,
      planId: plan._id,
    };

    Reflect.deleteProperty($scope.organizationConfiguration.plan, '_id');
  };

  $scope.setLFTOId = (lftoSelected) => {
    $scope.organization.defaultLineFlowTypeOrganization = lftoSelected._id;
  };

  $scope.setScenarioId = (scenarioSelected) => {
    $scope.organization.defaultScenario = scenarioSelected._id;
  };

  const findDuplicateCustomFields = (customFields) => {
    const uniqueNames = new Set(customFields.map((customField) => customField.name));

    const result = uniqueNames.size !== customFields.length;

    return result;
  };

  const validateGeneral = () => {
    const { name } = $scope.organizationGeneral;
    const { slug } = $scope.organizationGeneral;
    const { timezone } = $scope.organizationGeneral;
    const { language } = $scope.organizationGeneral;
    const { website } = $scope.organizationGeneral;
    const phoneNumber = validPhone($scope.organizationGeneral.phoneNumber);

    if (!name) {
      NotificationService.Warning($translate.instant('mandatory_name'));
      return false;
    }

    if (name && !namePattern.test(name)) {
      NotificationService.Warning($translate.instant('invalid_organization_name'));
      return false;
    }

    if (!slug) {
      NotificationService.Warning($translate.instant('mandatory_alias'));
      return false;
    }

    if (!language) {
      NotificationService.Warning($translate.instant('mandatory_language'));
      return false;
    }

    if (!timezone) {
      NotificationService.Warning($translate.instant('mandatory_timezone_place'));
      return false;
    }

    if (!$scope.data.selectedCategory || !$scope.data.selectedCategory.length > 0) {
      NotificationService.Warning($translate.instant('mandatory_category'));
      return false;
    }

    if (
      website &&
      !/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/.test(
        website.toLowerCase(),
      )
    ) {
      NotificationService.Warning($translate.instant('url regex'));
      return false;
    }
    if (phoneNumber && phoneNumber.length !== 10) {
      NotificationService.Warning($translate.instant('invalid_tel'));
      return false;
    }

    return true;
  };

  const validateCustomFields = () => {
    const customFields = get($scope.organizationConfiguration, 'customFields', []);

    const invalidCustomField = find(customFields, (item) => {
      if (!item.name || !item.label || !item.type) {
        return item;
      }
    });
    let emptyOption = false;
    customFields.forEach((cf) => {
      if (cf.type === 'radioButton' && cf.options.length === 0) {
        emptyOption = true;
      }
      if (cf.type === 'radioButton' && cf.options.length > 0) {
        for (const option of cf.options) {
          if (option === '') {
            emptyOption = true;
          }
        }
      }
    });

    if (emptyOption) {
      NotificationService.Warning($translate.instant('options_cannot_be_empty'));
      return false;
    }

    if (invalidCustomField) {
      NotificationService.Warning($translate.instant('custom_field_invalid'));
      return false;
    }

    if (findDuplicateCustomFields(customFields)) {
      NotificationService.Warning($translate.instant('organization.custom-fields.duplicate-name'));
      return false;
    }

    return true;
  };

  const populateSurveyMonkey = () => {
    const savedCompletedDelayDeliveryUnit = get(
      $scope.organization,
      'surveyMonkey.completed.delayDelivery.unit',
      null,
    );

    const completedSelectedOption = $scope.delayDeliveryUnitOfTime.options.find(
      (o) => o.key === savedCompletedDelayDeliveryUnit,
    );

    $scope.delayDeliveryUnitOfTime.completedSelectedOption = completedSelectedOption
      ? completedSelectedOption.key
      : $scope.delayDeliveryUnitOfTime.options[0].key;

    const savedCanceledDelayDeliveryUnit = get(
      $scope.organization,
      'surveyMonkey.canceled.delayDelivery.unit',
      null,
    );

    const canceledSelectedOption = $scope.delayDeliveryUnitOfTime.options.find(
      (o) => o.key === savedCanceledDelayDeliveryUnit,
    );

    $scope.delayDeliveryUnitOfTime.canceledSelectedOption = canceledSelectedOption
      ? canceledSelectedOption.key
      : $scope.delayDeliveryUnitOfTime.options[0].key;

    $scope.surveyMonkey = {
      completed: {
        enabled: get($scope.organization, 'surveyMonkey.completed.enabled', false),
        link: get($scope.organization, 'surveyMonkey.completed.link', ''),
        delayDelivery: {
          value: get($scope.organization, 'surveyMonkey.completed.delayDelivery.value', 0),
          unit: $scope.delayDeliveryUnitOfTime.completedSelectedOption,
        },
      },
      canceled: {
        enabled: get($scope.organization, 'surveyMonkey.canceled.enabled', false),
        link: get($scope.organization, 'surveyMonkey.canceled.link', ''),
        delayDelivery: {
          value: get($scope.organization, 'surveyMonkey.canceled.delayDelivery.value', 0),
          unit: $scope.delayDeliveryUnitOfTime.canceledSelectedOption,
        },
      },
    };
  };

  const validateSurveyMonkey = () => {
    const completedEnabled = get($scope.surveyMonkey, 'completed.enabled', false);
    const completedLink = get($scope.surveyMonkey, 'completed.link', '');
    const completedDelayDeliveryValue = get(
      $scope.surveyMonkey,
      'completed.delayDelivery.value',
      '',
    );
    const completedDelayDeliveryUnit = $scope.delayDeliveryUnitOfTime.completedSelectedOption;

    const canceledEnabled = get($scope.surveyMonkey, 'canceled.enabled', false);
    const canceledLink = get($scope.surveyMonkey, 'canceled.link', '');
    const canceledDelayDeliveryValue = get($scope.surveyMonkey, 'canceled.delayDelivery.value', '');
    const canceledDelayDeliveryUnit = $scope.delayDeliveryUnitOfTime.canceledSelectedOption;

    const minDelayDeliveryValue = 10;
    const minDelayDeliveryUnit = $scope.delayDeliveryUnitOfTime.options[0];

    if ((completedEnabled && !completedLink) || (canceledEnabled && !canceledLink)) {
      const message = $translate.instant(
        $translate.instant('mandatory_{name}').replace('{name}', 'link'),
      );
      NotificationService.Warning(message);
      return false;
    }

    if (
      (completedEnabled && !completedDelayDeliveryValue) ||
      (canceledEnabled && !canceledDelayDeliveryValue)
    ) {
      const message = $translate.instant(
        $translate
          .instant('mandatory_{name}')
          .replace('{name}', $translate.instant('survey_delay_delivery')),
      );
      NotificationService.Warning(message);
      return false;
    }

    if (
      (completedEnabled &&
        completedDelayDeliveryValue &&
        completedDelayDeliveryValue < minDelayDeliveryValue &&
        completedDelayDeliveryUnit === minDelayDeliveryUnit.key) ||
      (canceledEnabled &&
        canceledDelayDeliveryValue &&
        canceledDelayDeliveryValue < minDelayDeliveryValue &&
        canceledDelayDeliveryUnit === minDelayDeliveryUnit.key)
    ) {
      const message = $translate
        .instant('survey_delay_delivery_message_minimum_validation')
        .replace('{minValue}', minDelayDeliveryValue)
        .replace('{minUnit}', $translate.instant('seconds'));
      NotificationService.Warning(message);
      return false;
    }

    return true;
  };

  $scope.validationPeopleAhead = (value) => {
    $scope.errorPeopleAhead = !value;
  };

  const saveImages = (id, files) => {
    NotificationService.Information($translate.instant('uploading_images'));
    return OrganizationService.SaveImages(id, files)
      .then(() => NotificationService.Information($translate.instant('updated_images')))
      .catch(() => NotificationService.Error($translate.instant('err_update_image')));
  };

  $scope.saveGeneral = () => {
    if (validateGeneral()) {
      $scope.organizationGeneral.categories = $scope.data.selectedCategory.map(
        (category) => category.key,
      );
      $scope.organizationGeneral.images.agenda.headerBackground = $scope.headerBackground;
      OrganizationService.UpdateGeneral($scope.organizationGeneral, $scope.organization._id)
        .then(() => {
          NotificationService.Success($translate.instant('organization_update_succ'));
          if (
            $scope.file.hasOwnProperty('logo') ||
            $scope.file.hasOwnProperty('agenda.logo') ||
            $scope.file.hasOwnProperty('agenda.background')
          ) {
            saveImages($scope.organization._id, $scope.file);
          }
        })
        .catch(ErrorService.handler);
    }
  };

  const validateOneLogin = () => {
    if (!$scope.hack.organizationOneLoginEnabled) {
      return true;
    }

    const oneLogin = $scope.organizationOneLogin;
    const { passportConfig } = $scope.organizationOneLogin;

    if (!oneLogin.tenantId) {
      NotificationService.Warning($translate.instant('organization_onelogin_slug_required'));
      return false;
    }

    if (!passportConfig.clientID) {
      NotificationService.Warning($translate.instant('organization_onelogin_clientId_required'));
      return false;
    }

    if (!passportConfig.issuer) {
      NotificationService.Warning($translate.instant('organization_onelogin_issuer_required'));
      return false;
    }

    if (!passportConfig.tokenURL) {
      NotificationService.Warning($translate.instant('organization_onelogin_tokenurl_required'));
      return false;
    }

    if (!passportConfig.userInfoURL) {
      NotificationService.Warning($translate.instant('organization_onelogin_userinfourl_required'));
      return false;
    }

    if (!passportConfig.clientSecret) {
      NotificationService.Warning(
        $translate.instant('organization_onelogin_clientSecret_required'),
      );
      return false;
    }

    if (!passportConfig.authorizationURL) {
      NotificationService.Warning(
        $translate.instant('organization_onelogin_authorizationurl_required'),
      );
      return false;
    }

    if (!passportConfig.callbackURL) {
      NotificationService.Warning($translate.instant('organization_onelogin_callbackurl_required'));
      return false;
    }

    return true;
  };

  const validateAgendaConfigurations = () => {
    const showNextAvailableSlot = get(
      $scope.organization.configuration,
      'agenda.showNextAvailableSlot.enabled',
      false,
    );
    const showNextSlotInLessThan = get(
      $scope.organization.configuration,
      'agenda.showNextAvailableSlot.showNextSlotInLessThan',
      0,
    );

    const peopleAheadForConditions = get(
      $scope.organization.configuration,
      'agenda.showNextAvailableSlot.peopleAheadForConditions',
      0,
    );

    const warningMessage = get($scope.organization.configuration, 'agenda.warningMessage', '');
    const appointmentType = get(
      $scope.organization.configuration,
      'agenda.showNextAvailableSlot.appointment',
      false,
    );

    if (
      showNextAvailableSlot &&
      appointmentType &&
      (showNextSlotInLessThan < 1 || showNextSlotInLessThan > 480)
    ) {
      NotificationService.Warning($translate.instant('agenda_show_next_available_slot_range'));
      return false;
    }

    if (showNextAvailableSlot && peopleAheadForConditions < 1) {
      NotificationService.Warning($translate.instant('agenda_people_ahead_less_than_1'));
      return false;
    }

    if (warningMessage.length > 1500) {
      NotificationService.Warning($translate.instant('warning_message_too_long'));
      return false;
    }

    return true;
  };

  const validateConfigurations = () => {
    const { checkInTolerance } = $scope.organization.configuration.queuer;
    const { defaultScenario } = $scope.organization;
    const { checkIn } = $scope.organization.configuration;
    const { noAppointmentsAvailableMessage } = $scope.organization.configuration;
    const emailToSendCopiesEnabled = get(
      $scope.organization.configuration,
      'sendCopyEmail.enabled',
      false,
    );
    const emailToSendCopies = get($scope.organization.configuration, 'sendCopyEmail.email', '');
    const peopleAheadEmailEnabled = get(
      $scope.organization.configuration,
      'peopleAheadEmail.enabled',
      false,
    );
    const peopleAheadValue = get(
      $scope.organization.configuration,
      'peopleAheadEmail.people',
      null,
    );
    const overbookingQuantity = get($scope.organization, 'configuration.overbooking.quantity', 0);
    const emailField = $scope.endUserPersonalData.find((pd) => pd.name === 'email');
    const phoneNumberField = $scope.endUserPersonalData.find((pd) => pd.name === 'phoneNumber');
    const qmsRequiredField = $scope.endUserPersonalData.filter((pd) => pd.qmsRequired);

    if ($scope.scenarioList.length > 1 && !defaultScenario) {
      NotificationService.Warning($translate.instant('mandatory_defaultScenario'));
      return false;
    }

    if (!$scope.organization.configuration.queuer.qr) {
      $scope.organizationConfiguration.queuer.qr = `${Slug.slugify(
        $scope.organization.name,
      )}_check_in`;
    }

    if (
      checkInTolerance &&
      (checkInTolerance > 100 ||
        checkInTolerance < 2 ||
        checkInTolerance.toString().indexOf('.') === 1)
    ) {
      NotificationService.Warning($translate.instant('organization_checkin_tolerance_range'));
      return false;
    }

    if (!checkIn || !checkIn.max || checkIn.max < 5 || checkIn.max > 1000) {
      NotificationService.Warning($translate.instant('error_pre_check_in_invalid_range'));
      return false;
    }

    if (!checkIn || !checkIn.min || checkIn.min < 5 || checkIn.min > 1000) {
      NotificationService.Warning($translate.instant('error_pre_check_in_invalid_range'));
      return false;
    }

    if (!validateOneLogin()) {
      return false;
    }

    if (noAppointmentsAvailableMessage.length > 150) {
      NotificationService.Warning($translate.instant('noAppointments_message_too_long'));
      return false;
    }

    if (emailToSendCopiesEnabled && !$scope.validEmail.test(emailToSendCopies)) {
      NotificationService.Warning($translate.instant('invalid_email_to_send_copy'));
      return false;
    }

    if (peopleAheadEmailEnabled && !peopleAheadValue) {
      NotificationService.Warning(
        $translate.instant(
          $translate
            .instant('mandatory_{name}')
            .replace('{name}', $translate.instant('people_ahead')),
        ),
      );
      return false;
    }

    if (
      peopleAheadValue &&
      (peopleAheadValue < $scope.minPeopleAheadValue ||
        peopleAheadValue > $scope.maxPeopleAheadValue)
    ) {
      NotificationService.Warning(
        $translate.instant(
          $translate
            .instant('people_ahead_out_of_boundary')
            .replace('{min}', $scope.minPeopleAheadValue)
            .replace('{max}', $scope.maxPeopleAheadValue),
        ),
      );
      return false;
    }
    const appointmentReminderEnabled =
      $scope.organization.configuration.appointmentReminder.enabled;
    const { sendWhen } = $scope.organization.configuration.appointmentReminder;
    const { time } = $scope.organization.configuration.appointmentReminder;
    if (
      appointmentReminderEnabled &&
      (sendWhen === '' || !sendWhen || !time || time.hour === '' || time.minute === '')
    ) {
      NotificationService.Warning($translate.instant('invalid_appointment_reminder_configuration'));
      return false;
    }

    if (!validateCustomFields()) {
      return false;
    }

    if (!isNumber(overbookingQuantity) || overbookingQuantity > 30 || overbookingQuantity < 1) {
      NotificationService.Warning($translate.instant('overbooking_max_min'));
      return false;
    }

    if (!emailField.webAgendaRequired && !phoneNumberField.webAgendaRequired) {
      NotificationService.Warning(
        $translate
          .instant('email_or_phone_number_required')
          .replace('{sectionName}', $translate.instant('agendas_show_required_fields_settings')),
      );
      return false;
    }

    if (!qmsRequiredField.length) {
      NotificationService.Warning(
        $translate
          .instant('qms_at_least_one_field_required')
          .replace('{sectionName}', $translate.instant('qms_show_required_fields_settings')),
      );
      return false;
    }

    return true;
  };

  $scope.changeAppointmentReminder = (when) => {
    $scope.organization.configuration.appointmentReminder.sendWhen = when;
  };

  $scope.saveAgendaConfigurations = () => {
    if (validateAgendaConfigurations()) {
      OrganizationService.UpdateAgendaConfigurations(
        $scope.organizationAgenda,
        $scope.organization._id,
      )
        .then(() => NotificationService.Success($translate.instant('organization_update_succ')))
        .catch(() => NotificationService.Error($translate.instant('err_operation')));
    }
  };

  const covertArrayDataToObject = (arr, key) =>
    arr.reduce((acc, curr) => {
      const value = {
        qms: {
          show: curr.qmsShow,
          required: curr.qmsRequired,
        },
        webAgenda: {
          show: curr.webAgendaShow,
          required: curr.webAgendaRequired,
        },
      };
      acc[curr[key]] = value;
      return acc;
    }, {});

  $scope.saveConfigurations = () => {
    if (validateConfigurations()) {
      const oneLogin = $scope.hack.organizationOneLoginEnabled ? $scope.organizationOneLogin : null;

      const { defaultLineFlowTypeOrganization } = $scope.organization;

      const { defaultScenario } = $scope.organization;

      const noAppointmentsAvailableApplyIn =
        $scope.noAppointmentsAvailableMessageApplyIn.selectedOption;
      $scope.organizationConfiguration.noAppointmentsAvailableApplyIn = noAppointmentsAvailableApplyIn;

      const email = $scope.organization.configuration.sendCopyEmail.enabled
        ? $scope.organization.configuration.sendCopyEmail.email
        : '';
      const sendCopyEmail = {
        enabled: $scope.organization.configuration.sendCopyEmail.enabled,
        email,
      };
      $scope.organizationConfiguration.sendCopyEmail = sendCopyEmail;

      const peopleAheadEmail = {
        enabled: $scope.organization.configuration.peopleAheadEmail.enabled,
        people: $scope.organization.configuration.peopleAheadEmail.enabled
          ? $scope.organization.configuration.peopleAheadEmail.people
          : null,
      };
      $scope.organizationConfiguration.peopleAheadEmail = peopleAheadEmail;
      for (let i = 0; i < $scope.organizationConfiguration.customFields.length; i++) {
        if ($scope.organizationConfiguration.customFields[i].type === 'radioButton') {
          Reflect.deleteProperty($scope.organizationConfiguration.customFields[i], 'currentOption');
        }
      }

      const overbookingApplyIn = $scope.selectDataForOverbooking.selectedOption;

      $scope.organizationConfiguration.endUserPersonalData = covertArrayDataToObject(
        $scope.endUserPersonalData,
        'name',
      );

      const userDataSettingsApplyIn = $scope.applyUserDataSettings.selectedOption;

      const overlapAppointmentApplyIn = $scope.overlapAppointment.selectedOption;

      OrganizationService.UpdateConfiguration(
        {
          configuration: $scope.organizationConfiguration,
          enabledForMobileApp: $scope.organization.enabledForMobileApp,
          hiddenInMobileApp: $scope.organization.hiddenInMobileApp,
          defaultLineFlowTypeOrganization,
          lineFlowTypeApplyIn: $scope.editCallLogicsScope.selectedOption,
          defaultScenario,
          oneLogin,
          overbookingApplyIn,
          userDataSettingsApplyIn,
          overlapAppointmentApplyIn,
        },
        $scope.organization._id,
      )
        .then(() => NotificationService.Success($translate.instant('organization_update_succ')))
        .catch(() => NotificationService.Error($translate.instant('err_operation')));
    }
  };

  const validateMessages = () => {
    const { organizationMessages } = $scope;
    const messagesCondition = organizationMessages.find((organizationMessage) =>
      organizationMessage.messages.find((message) => !message),
    );
    if (messagesCondition) {
      NotificationService.Warning($translate.instant('messages_required'));
      return false;
    }
    return true;
  };

  const saveSurveyMonkeySettings = () => {
    let surveyMonkeyCompleted = {
      enabled: false,
    };

    let surveyMonkeyCanceled = {
      enabled: false,
    };

    if (get($scope.surveyMonkey, 'completed.enabled', false)) {
      surveyMonkeyCompleted = {
        enabled: true,
        link: get($scope.surveyMonkey, 'completed.link'),
        delayDelivery: {
          value: get($scope.surveyMonkey, 'completed.delayDelivery.value'),
          unit: $scope.delayDeliveryUnitOfTime.completedSelectedOption,
        },
      };
    }

    if (get($scope.surveyMonkey, 'canceled.enabled', false)) {
      surveyMonkeyCanceled = {
        enabled: true,
        link: get($scope.surveyMonkey, 'canceled.link'),
        delayDelivery: {
          value: get($scope.surveyMonkey, 'canceled.delayDelivery.value'),
          unit: $scope.delayDeliveryUnitOfTime.canceledSelectedOption,
        },
      };
    }

    const surveyMonkey = {
      completed: surveyMonkeyCompleted,
      canceled: surveyMonkeyCanceled,
    };

    return surveyMonkey;
  };

  $scope.saveMessages = () => {
    if (validateMessages()) {
      const forAllPlaces = $scope.editMessagesScope.selectedOption === 'all';

      OrganizationMessagesService.UpdateAllMessages(
        $scope.organizationMessages,
        $scope.organization._id,
        forAllPlaces,
      )
        .then(() => NotificationService.Success($translate.instant('organization_update_succ')))
        .catch(() => NotificationService.Error($translate.instant('err_operation')));
    }
  };

  $scope.saveSurveyMonkey = () => {
    if (validateSurveyMonkey()) {
      const surveyMonkey = saveSurveyMonkeySettings();

      OrganizationService.UpdateSurveyMonkey(surveyMonkey, $scope.organization._id)
        .then(() => NotificationService.Success($translate.instant('organization_update_succ')))
        .catch(() => NotificationService.Error($translate.instant('err_operation')));
    }
  };

  const validateEmails = (emails) => {
    if (!isEmpty(emails.subjects.filter((s) => s.subject.length > 100))) {
      NotificationService.Warning($translate.instant('invalid_email_subject_length'));
      return false;
    }

    if (emails.prefix && emails.prefix.length > 50) {
      NotificationService.Warning($translate.instant('invalid_email_prefix_length'));
      return false;
    }

    return true;
  };

  $scope.saveEmails = () => {
    const emails = get($scope.organization, 'emails', []);

    if (validateEmails(emails)) {
      if (get(emails, 'banner.link', null)) {
        const transformedLink = get(emails, 'banner.link').toLowerCase();
        set(emails, 'banner.link', transformedLink);
      }

      OrganizationService.UpdateEmails({ emails }, $scope.organization._id)
        .then(() => {
          NotificationService.Success($translate.instant('organization_update_succ'));
          if (
            $scope.file.hasOwnProperty('emailsBanner') ||
            $scope.file.hasOwnProperty('emailsFooter')
          ) {
            saveImages($scope.organization._id, $scope.file);
          }
        })
        .catch(() => NotificationService.Error($translate.instant('err_operation')));
    }
  };

  $scope.addReason = () => {
    $scope.organization.configuration.reasons.unshift('');
  };

  $scope.deleteReason = (reason) => {
    dialog
      .confirm($translate.instant('reason_remove_sure'))
      .then(() => {
        pull($scope.organization.configuration.reasons, reason);
        NotificationService.Information($translate.instant('reason_remove_succ'));
      })
      .catch(ErrorService.handler);
  };

  $scope.requestReasonAndMotiveChange = (value) => {
    $scope.organization.configuration.reasons = [];
    if (!value) {
      $scope.organization.configuration.reasonRequired = false;
    }
  };

  $scope.userBoxChange = (value) => {
    if (value) {
      $scope.organization.configuration.queuer.boxLabelRequired = false;
    }
  };

  $scope.adminBoxChange = (value) => {
    if (value) {
      $scope.organization.configuration.user.useBoxLabelByPace.enabled = false;
      $scope.organization.configuration.user.useBoxLabelByPace.required = false;
      $scope.organization.configuration.user.useBoxLabelByPace.isNumeric = false;
    }
  };

  $scope.defaultAppointmentConfirmation = () => {
    if (
      !$scope.organizationConfiguration.queuer.canGiveAppointments ||
      !$scope.organizationConfiguration.queuer.canConfirmAppointments
    ) {
      $scope.organizationConfiguration.queuer.requireAppointmentConfirmation = false;
    }
    if (!$scope.organizationConfiguration.queuer.canGiveAppointments) {
      $scope.organization.configuration.queuer.showWorkingDay = false;
    }
    if (!$scope.organization.configuration.queuer.canGiveAppointments) {
      $scope.organization.configuration.queuer.canProcessAppointment = false;
    }
    if ($scope.organizationConfiguration.queuer.canGiveAppointments) {
      $scope.organizationConfiguration.queuer.canConfirmAppointments = true;
    }
  };

  $scope.isDynamicAlias = () => {
    const aliasType = get($scope, 'organization.configuration.queuer.aliasType');
    const aliasGetter = get($scope, 'organization.configuration.queuer.aliasGetter');
    const isDinamycAlias = aliasType === 'dynamicAlias';

    if (isDinamycAlias && !aliasGetter) {
      const fun = `
        /* context = {_, subscription}
          * _ = lodash
          * virtualine subscription
          */
        (function() { return _.get(subscription, '_id', 'default-value')}());
              `;
      set($scope, 'organization.configuration.queuer.aliasGetter', fun);
    }

    return isDinamycAlias;
  };

  $scope.uploadFile = (files, type) => {
    if (files.length > 0) {
      const ext = files[0].name.match(/\.(.+)$/)[1];
      $timeout(() => {
        $scope.file[type] = files[0];
      });
      if (
        !angular.lowercase(ext) === 'jpg' ||
        !angular.lowercase(ext) === 'jpeg' ||
        !angular.lowercase(ext) === 'png'
      ) {
        NotificationService.Warning($translate.instant('invalid_file_format'));
      }
    }
  };

  $scope.deleteImage = (type) => {
    const defaultImage = 'img/common/placeholder-place.png';
    $timeout(() => {
      $scope.file[type] = null;
      switch (type) {
        case 'logo':
          $scope.logoSrc = defaultImage;
          break;
        case 'agenda.logo':
          $scope.agendaLogoSrc = defaultImage;
          break;
        case 'agenda.background':
          $scope.agendaBackgroundSrc = defaultImage;
          break;
        case 'emailsBanner':
          $scope.emailsBannerImage = defaultImage;
          break;
        case 'emailsFooter':
          $scope.emailsFooterImage = defaultImage;
          break;
        default:
          break;
      }
    });
  };

  $scope.addCustomFields = () => {
    const customFieldEmpty = {
      name: '',
      label: '',
      type: 'text',
      required: false,
      validation: '',
    };

    if (!$scope.organizationConfiguration.customFields) {
      $scope.organizationConfiguration.customFields = [];
    }

    $scope.organizationConfiguration.customFields.push(customFieldEmpty);
  };

  $scope.changeType = (type, index) => {
    $scope.organizationConfiguration.customFields[index].currentOption = '';
    $scope.organizationConfiguration.customFields[index].options = [];
  };

  $scope.inputOption = (event, index) => {
    const key = event.which;
    const { currentOption } = $scope.organizationConfiguration.customFields[index];
    // The key 188 can be a comma (,) or a less than sign (<) depending on keyboard layouts or keyboard language
    // source: https://lists.w3.org/Archives/Public/www-dom/2010JulSep/att-0182/keyCode-spec.html#fixed-virtual-key-codes
    if (
      (key === 188 && currentOption !== ',' && currentOption !== '<') ||
      (key === 13 && currentOption !== ' ')
    ) {
      const option =
        currentOption.indexOf(',') !== -1
          ? currentOption.substring(0, currentOption.indexOf(','))
          : currentOption;
      $scope.organizationConfiguration.customFields[index].options.push(option);
      $scope.organizationConfiguration.customFields[index].currentOption = '';
    }
  };

  $scope.remove = (option, customField) => {
    const index = $scope.organizationConfiguration.customFields.indexOf(customField);
    $scope.organizationConfiguration.customFields[index].options.splice(
      $scope.organizationConfiguration.customFields[index].options.indexOf(option),
      1,
    );
  };

  $scope.removeCustomFields = (customField) => {
    dialog
      .confirm($translate.instant('custom_field_confirm_remove'))
      .then(() => {
        const index = $scope.organizationConfiguration.customFields.indexOf(customField);
        $scope.organizationConfiguration.customFields.splice(index, 1);
      })
      .catch(() => {});
  };

  $scope.disabledAddCustomFields = () => {
    const lengthCustomFields = get($scope.organizationConfiguration, 'customFields.length', 0);
    return lengthCustomFields >= 10;
  };

  const init = () => {
    const enqueueBlock = blockUI.instances.get('organization-modal');
    enqueueBlock.start();

    const categoriesPromises = CategoryService.GetAllAsPromise();
    const aliasTypesPromises = OrganizationService.GetAliasTypes();

    const organizationMessagesPromise = organizationId
      ? OrganizationMessagesService.GetAllAsPromise(organizationId)
      : [];

    const organizationPromise = organizationId
      ? OrganizationService.GetOneAsPromiseFromServer(organizationId)
      : null;

    const lftoPromise = organizationId
      ? LineFlowTypeOrganizationService.GetAllEnabledByOrganization(organizationId, false)
      : [];

    const scenarioPromise = organizationId
      ? OrganizationScenarioService.GetAll(organizationId)
      : [];

    const plansPromise = $scope.superAdmin ? PlanService.GetAllActive() : [];

    const promises = [
      categoriesPromises,
      aliasTypesPromises,
      organizationMessagesPromise,
      organizationPromise,
      lftoPromise,
      scenarioPromise,
      plansPromise,
    ];

    return Promise.all(promises)
      .then(([categories, aliasTypes, messages, organization, lftoList, scenarioList, plans]) => {
        $scope.data = {
          aliasTypes,
          categories,
          selectedCategory: [],
        };

        $scope.plans = plans;

        if (organizationId) {
          $timeout(() => {
            $scope.lineFlowTypeOrganizationList = lftoList;

            $scope.lineFlowTypeOrganizationSelected =
              find(lftoList, ['_id', organization.defaultLineFlowTypeOrganization]) ||
              lineFlowTypeOrganizationList[0];

            const defaultMessages = OrganizationMessagesService.GetDefaults();

            const newMessages = filter(defaultMessages, (dm) => !some(messages, ['slug', dm.slug]));

            messages = [...newMessages, ...messages];

            messages = messages.filter(Boolean);
            messages.forEach(({ messages: byLanguage }) => {
              const newLanguages = difference(SUPPORTED_LANGUAGES, map(byLanguage, 'language'));

              if (newLanguages) {
                const deafultMessage = find(byLanguage, ['language', 'en']);
                newLanguages.forEach((lng) =>
                  byLanguage.push({ ...deafultMessage, language: lng }),
                );
              }
            });

            $scope.organizationMessages = messages;
            $scope.organization = OrganizationService.Copy(organization);
            const appointmentReminderConfig = get(
              $scope.organization,
              'configuration.appointmentReminder',
            );
            if (!appointmentReminderConfig.enabled && !appointmentReminderConfig.sendWhen) {
              $scope.organization.configuration.appointmentReminder.enabled = true;
              $scope.organization.configuration.appointmentReminder.sendWhen = 'dayBefore';
              $scope.organization.configuration.appointmentReminder.time.hour = '18';
              $scope.organization.configuration.appointmentReminder.time.minute = '00';
            }
            $scope.organizationGeneral = $scope.organization.getGeneralPartial();
            $scope.headerBackground = get(
              $scope.organizationGeneral,
              'images.agenda.headerBackground',
              '',
            );
            $scope.organizationConfiguration = omit($scope.organization.getConfigurationPartial(), [
              'agenda',
              'allowAppointmentsByIdentification',
            ]);
            $scope.organizationAgenda = pick($scope.organization.getConfigurationPartial(), [
              'agenda',
              'allowAppointmentsByIdentification',
            ]);
            const userDataSettings = $scope.organizationConfiguration.endUserPersonalData;
            $scope.idFieldRequired =
              (userDataSettings.identification.webAgenda.required &&
                userDataSettings.identification.qms.required) ||
              false;
            $scope.nameAndLastNameFieldsRequired =
              (userDataSettings.name.webAgenda.required &&
                userDataSettings.lastName.webAgenda.required &&
                userDataSettings.name.qms.required &&
                userDataSettings.lastName.qms.required) ||
              false;
            const isAirport = $scope.organization.categories.indexOf('airport') > -1;
            getSlugForEmails(isAirport);
            getImagesForEmails();
            getEndUserPersonalData();
            const organizationOneLogin = $scope.organization.getOneLoginConfigurationPartial();
            $scope.organizationOneLogin = organizationOneLogin;
            $scope.hack.organizationOneLoginEnabled = organizationOneLogin.enabled;

            $scope.organization.categories.forEach((category) => {
              const c = find($scope.data.categories, ['key', category]);
              if (c) {
                $scope.data.selectedCategory.push(c);
              }
            });

            $scope.scenarioList = scenarioList;
            $scope.scenarioList.unshift({
              name: '',
              value: '',
            });

            $scope.scenarioSelected =
              find(scenarioList, ['_id', organization.defaultScenario]) || scenarioList[0];
            $scope.logoSrc =
              organization.images.logo ||
              organization.images.thumbnail ||
              'img/common/placeholder-place.png';
            $scope.agendaLogoSrc = organization.images.agenda.logo
              ? organization.images.agenda.logo
              : 'img/common/placeholder-place.png';
            $scope.agendaBackgroundSrc = organization.images.agenda.background
              ? organization.images.agenda.background
              : 'img/common/placeholder-place.png';

            populateSurveyMonkey();
          });
        }

        enqueueBlock.stop();
      })
      .catch(() => $scope.cancel());
  };

  $scope.changeShowNextAvailableSlotEnabled = () => {
    set($scope.organization, 'configuration.agenda.showNextAvailableSlot.appointment', true);
    set(
      $scope.organization,
      'configuration.agenda.autoCheckinAppointmentsForNextAvailableSlot',
      false,
    );
  };

  $scope.changeTypeAppointment = () => {
    set(
      $scope.organization,
      'configuration.agenda.showNextAvailableSlot.enableAppointmentCalendar',
      true,
    );
  };

  $scope.changeHeaderBackground = (value) => {
    $scope.headerBackground = value;
  };

  $scope.disablePersonalDataAlias = (value) => {
    $scope.disableFullNameAlias = value;
    if (value && $scope.organizationConfiguration.queuer.aliasType) {
      $scope.organizationConfiguration.queuer.aliasType = 'prefixWithIncrementalNumberAlias';
    }
  };

  init();
};

module.exports = module.controller('OrganizationModalController', OrganizationModalController);
